<template>
  <div id="dataAndCases">
    <bread :content="breadContent"></bread>
    <p class="Page-title">
      {{ pageTypeCN[pageState] }}
      <span class="title--inactive" @click="changeState((pageState + 1) % 4)">{{ pageTypeCN[(pageState + 1) % 4] }}</span>
      <span class="title--inactive" @click="changeState((pageState + 2) % 4)">{{ pageTypeCN[(pageState + 2) % 4] }}</span>
      <span class="title--inactive" @click="changeState((pageState + 3) % 4)">{{ pageTypeCN[(pageState + 3) % 4] }}</span>
    </p>
    <el-divider></el-divider>
    <laws-table :data="tableData" :collections="collections" @collect="getData" :loading="tableLoading"></laws-table>
  </div>
</template>
<script>
import bread from "@/components/bread";
import lawsTable from "@/components/dataAndCases/lawsTable";

export default {
  name: "dataAndCases",
  components: {
    bread,
    lawsTable
  },
  data() {
    return {
      pageState: 0,
      pageTypeCN: ["应急法律法规", "应急管理案例", "应急管理论文", "收藏"],
      pageType: ["laws", "cases", "papers", "collection"],
      tableData: [],
      collections: [],

      tableLoading: false
    }
  },
  computed: {
    breadContent() {
      return [
        { text: "首页", routerName: "index" },
        { text: "学习资料与案例库", routerName: "dataAndCases" },
        { text: this.pageTypeCN[this.pageState], routerName: "" }
      ];
    }
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: "getData"
  },
  methods: {
    changeState(newPageState) {
      this.pageState = newPageState;
      this.$router.push({ params: { type: this.pageType[newPageState] } });
    },
    async getData() {
      this.tableData = [];
      this.pageState = this.pageType.findIndex(
        item => item === this.$route.params.type
      );
      let res;
      switch (this.pageState) {
        case 0:
          res = (await this.$net.dataAndCases.getLaws()) || [];
          break;
        case 1:
          res = (await this.$net.dataAndCases.getCases()) || [];
          break;
        case 2:
          res = (await this.$net.dataAndCases.getPapers()) || [];
          break;
        case 3:
          if (localStorage.Authorization) {
            res = (await this.$net.dataAndCases.getCollections()) || [];
          } else {
            alert("登录后才可以进行收藏");
            return;
          }
        // this.tableData = this.$store.state.caseCollection
        // this.downloadUrls = this.$store.state.caseCollection.map(item => item.downloadUrl)
      }
      let data = [];
      if (res) {
        res.forEach(item => {
          data.push(Object.values(item));
        });
        this.tableData = data;
      }
      // 获取收藏
      if (this.pageState !== 3) {
        let data2 = [];
        if (localStorage.Authorization) {
          const res2 = (await this.$net.dataAndCases.getCollections()) || [];
          res2.forEach(item => {
            data2.push(Object.values(item));
          });
          this.collections = data2;
        }
      } else {
        this.collections = data;
      }
    }
  },
  async created() {
    this.tableLoading = true
    await this.getData()
    this.tableLoading = false
  }
};
</script>
<style lang="scss" scoped>
#dataAndCases {
  width: 70%;
  margin: 0 auto;
  margin-top: 40px;
  padding: 40px 0 160px 0;
  .title--inactive {
    font-size: 18px;
    color: #000;
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>

